import GiftCoin from './index';

export default { path: '/home/giftCoin', component: GiftCoin };
